import { getBetTitleSingleBetProps, getBetStatusLabelProps, getBonusDetailsListProps, getTotalReturnProps, getBetSummaryProps, isBonusAvailable } from "../bet";
import { getMarketNameProps, getEventDetailsSingleProps, isSelectionNotFixture } from "../selection";
export const getSingleBetProps = (bet, state) => {
    // TODO: Rename 'isOutright' to 'isNotFixture' once changed in contract
    const isOutright = isSelectionNotFixture(bet.selections[0]);
    const props = {
        isOutright,
        betTitle: getBetTitleSingleBetProps(bet, bet.selections[0], state),
        betStatusLabel: getBetStatusLabelProps(bet, state),
        marketName: getMarketNameProps(bet.selections[0]),
        totalReturn: getTotalReturnProps(bet, state),
        eventDetails: getEventDetailsSingleProps(bet.type, bet.selections[0], state),
        betSummary: getBetSummaryProps(bet, state)
    };
    if (isBonusAvailable(bet)) {
        props.bonusDetailsList = getBonusDetailsListProps(bet, state);
    }
    return props;
};
//# sourceMappingURL=getSingleBetProps.js.map